import { Form, Modal, Input, message, Button, AutoComplete, Typography, Row, Col, Divider, Tooltip } from "antd";
import { useEffect, useState } from "react";
import AnimateItems from "../../../../utils/AnimateItems";
import axios from "axios";

export default function PruebasForm(props) {
  const { title, mainData: visita, setMainData, visible, setVisible, verification } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible && visita) {
      form.setFieldsValue({
        ResResistenciaAislamiento: visita.ResResistenciaAislamiento || "",
        EqResistenciaAislamiento: visita.EqResistenciaAislamiento || "",
        DescAislamiento: visita.DescAislamiento || "",
        ObsAislamiento: visita.ObsAislamiento || "",

        ResContinuidadElectrica: visita.ResContinuidadElectrica || "",
        EqContinuidadElectrica: visita.EqContinuidadElectrica || "",
        DescContinuidad: visita.DescContinuidad || "",
        ObsContinuidad: visita.ObsContinuidad || "",

        ResResistenciaTierraFisica: visita.ResResistenciaTierraFisica || "",
        EqResistenciaTierraFisica: visita.EqResistenciaTierraFisica || "",
        DescElectrodos: visita.DescElectrodos || "",
        ObsElectrodos: visita.ObsElectrodos || "",

        ResPolaridadContactos: visita.ResPolaridadContactos || "",
        EqPolaridadContactos: visita.EqPolaridadContactos || "",
        DescPolaridad: visita.DescPolaridad || "",
        ObsPolaridad: visita.ObsPolaridad || "",

        ObsProtecciones: visita.ObsProtecciones || "",
        ObsLocalesSubestaciones: visita.ObsLocalesSubestaciones || "",
        ObsSistemasEmergencia: visita.ObsSistemasEmergencia || "",
      });
    }
  }, [visita, form, visible]);

  const isPeriodic = verification?.TipoVerificacionID === 5;
  const noAplicaOption = [{ value: "NO APLICA" }];

  return (
    <Modal title={title} visible={visible} onCancel={() => setVisible(false)} footer={null} width={1000} centered>
      <Form form={form} layout="vertical">
        <AnimateItems delay={0.15}>
          <Row gutter={24}>
            <Col span={12}>
              <Typography.Title level={5}>1. Resistencia aislamiento</Typography.Title>
              <Form.Item name="ResResistenciaAislamiento" label="Resultado">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="EqResistenciaAislamiento" label="Equipo">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="DescAislamiento" label="Descripción">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="ObsAislamiento" label="Observaciones para el Anexo B">
                <Tooltip title={!isPeriodic ? "No es instalación construída antes de la NOM-001-SEDE-2012" : ""}>
                  <span>
                    <AutoComplete options={noAplicaOption} disabled={!isPeriodic} placeholder={!isPeriodic ? "No aplica para este tipo de verificación" : ""} />
                  </span>
                </Tooltip>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Typography.Title level={5}>2. Continuidad eléctrica de envolventes</Typography.Title>
              <Form.Item name="ResContinuidadElectrica" label="Resultado">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="EqContinuidadElectrica" label="Equipo">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="DescContinuidad" label="Descripción">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="ObsContinuidad" label="Observaciones para el Anexo B">
                <Tooltip title={!isPeriodic ? "No es instalación construída antes de la NOM-001-SEDE-2012" : ""}>
                  <span>
                    <AutoComplete options={noAplicaOption} disabled={!isPeriodic} placeholder={!isPeriodic ? "No aplica para este tipo de verificación" : ""} />
                  </span>
                </Tooltip>
              </Form.Item>
            </Col>
          </Row>

          <Divider />

          <Row gutter={24}>
            <Col span={12}>
              <Typography.Title level={5}>3. Resistencia de electrodos</Typography.Title>
              <Form.Item name="ResResistenciaTierraFisica" label="Resultado">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="EqResistenciaTierraFisica" label="Equipo">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="DescElectrodos" label="Descripción">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="ObsElectrodos" label="Observaciones para el Anexo B">
                <Tooltip title={!isPeriodic ? "No es instalación construída antes de la NOM-001-SEDE-2012" : ""}>
                  <span>
                    <AutoComplete options={noAplicaOption} disabled={!isPeriodic} placeholder={!isPeriodic ? "No aplica para este tipo de verificación" : ""} />
                  </span>
                </Tooltip>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Typography.Title level={5}>4. Polaridad en receptáculos</Typography.Title>
              <Form.Item name="ResPolaridadContactos" label="Resultado">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="EqPolaridadContactos" label="Equipo">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="DescPolaridad" label="Descripción">
                <AutoComplete options={noAplicaOption} />
              </Form.Item>
              <Form.Item name="ObsPolaridad" label="Observaciones para el Anexo B">
                <Tooltip title={!isPeriodic ? "No es instalación construída antes de la NOM-001-SEDE-2012" : ""}>
                  <span>
                    <AutoComplete options={noAplicaOption} disabled={!isPeriodic} placeholder={!isPeriodic ? "No aplica para este tipo de verificación" : ""} />
                  </span>
                </Tooltip>
              </Form.Item>
            </Col>
          </Row>

          {isPeriodic && (
            <>
              <Divider>Solo para Anexo B</Divider>
              <Row gutter={24}>
                <Col span={8}>
                  <Form.Item name="ObsProtecciones" label="Protecciones, desconectadores y envolventes">
                    <AutoComplete options={noAplicaOption} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="ObsLocalesSubestaciones" label="Locales de Subestaciones">
                    <AutoComplete options={noAplicaOption} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="ObsSistemasEmergencia" label="Sistemas de Emergencia y de Reserva">
                    <AutoComplete options={noAplicaOption} />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </AnimateItems>
      </Form>
      <Button
        type="primary"
        onClick={() => {
          const visitData = { ...visita, ...form.getFieldsValue() };
          axios
            .put(`${process.env.REACT_APP_API_URL}/visitas/${visita.VisitaID}`, visitData)
            .then(() => {
              message.success("Campos actualizados correctamente");
              setVisible(false);
              axios
                .get(`${process.env.REACT_APP_API_URL}/visitas/${visita.VerificacionID}`)
                .then((res) => {
                  message.success("Lista de visitas actualizada correctamente");
                  setMainData(res.data);
                })
                .catch((err) => {
                  console.log(err);
                  message.error("Error al actualizar la lista de visitas");
                });
            })
            .catch((err) => {
              console.log(err);
              message.error("Error al actualizar los campos");
            });
        }}
      >
        Guardar
      </Button>
    </Modal>
  );
}
